export interface PropertyType {
  id: number;
  name: string;
  icon?: string;
}

export interface PropertyTypeDefinition {
  id: number;
  nameKey: string;
  icon?: string;
}

export const PROPERTY_TYPE_DEFINITIONS: PropertyTypeDefinition[] = [
  { id: 1, nameKey: 'objects.wizard.propertyTypes.hotel', icon: 'pi pi-building' },
  { id: 2, nameKey: 'objects.wizard.propertyTypes.guesthouse', icon: 'pi pi-warehouse' },
  { id: 3, nameKey: 'objects.wizard.propertyTypes.apartment', icon: 'pi pi-th-large' },
  { id: 5, nameKey: 'objects.wizard.propertyTypes.cottage', icon: 'pi pi-sun' },
  { id: 6, nameKey: 'objects.wizard.propertyTypes.villa', icon: 'pi pi-crown' },
  { id: 7, nameKey: 'objects.wizard.propertyTypes.glamping', icon: 'pi pi-compass' },
  { id: 8, nameKey: 'objects.wizard.propertyTypes.guestRooms', icon: 'pi pi-users' },
  { id: 9, nameKey: 'objects.wizard.propertyTypes.agritourism', icon: 'pi pi-leaf' },
  { id: 10, nameKey: 'objects.wizard.propertyTypes.camping', icon: 'pi pi-map' },
  { id: 11, nameKey: 'objects.wizard.propertyTypes.hostel', icon: 'pi pi-building-columns' },
  { id: 12, nameKey: 'objects.wizard.propertyTypes.camperTrailers', icon: 'pi pi-truck' },
];
